import propTypes from 'prop-types';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import Button, { IconButton } from '../Button';
import PageSectionHeader from './PageSectionHeader';
import PageSectionHeaderAction from './PageSectionHeaderAction';
import PageSectionHeaderHead from './PageSectionHeaderHead';
import { StreakDropdown } from './streak';
import { useMediaQuery } from 'react-responsive';
function PageHeader({
  children,
  notificationCount,
  goBackLink,
  streakData,
  cartCount,
  setIsCartOpen,
  staff,
  notificationMenu,
  notificationLink,
  languageSelector,
  resetBackLink,
  darkModeToggle,
  extraActions,
}) {
  function GoBackButton() {
    const isMobile = useMediaQuery({ maxWidth: 768 });
    if (goBackLink) {
      return (
        <Button variant="ghost" className="go-back-button" iconBefore="arrow-left-s" iconType="line" as={Link} to={goBackLink} onClick={resetBackLink}>
          {!isMobile && children}
        </Button>
      );
    }
    return children;
  }

  const isTablet = useMediaQuery({ query: '(min-width: 768px)' });
  const navigate = useNavigate();
  return (
    <div className="page-header">
      <div className="page-header__content">
        <GoBackButton>
          {children}
        </GoBackButton>
      </div>
      <div className="page-header__head">
        {extraActions && isTablet && <div className="page-header__extra-actions">{extraActions}</div>}
        <div className="page-header__actions">
          {!staff && <StreakDropdown data={streakData} />}
          {!staff && cartCount > 0 && <IconButton variant="ghost-gray" icon="shopping-cart" badge={cartCount} role="button" aria-label="shopping cart" onClick={() => setIsCartOpen(true)} />}
          {languageSelector}
          {/* Dark mode/light mode toggle */}
          {darkModeToggle}
          <Dropdown>
            <Dropdown.Toggle
              as={IconButton}
              variant="ghost-gray"
              icon="notification-3"
              badge={notificationCount}
              role="button"
              aria-label="notification"
              className="notification-button"
              {...(!isTablet && {
                href: notificationLink ? notificationLink : "#"
              })}
            />
            {isTablet && notificationMenu}
          </Dropdown>
        </div>
      </div>
    </div>
  );
}

PageHeader.propTypes = {
  children: propTypes.node,
  streakCount: propTypes.number,
  notificationCount: propTypes.number,
  goBackLink: propTypes.string,
  cartData: propTypes.array,
  setIsCartOpen: propTypes.func,
  setIsNotificationOpen: propTypes.func,
  cartCount: propTypes.number,
  languageSelector: propTypes.node,
  darkModeToggle: propTypes.node,
  extraActions: propTypes.node,
};

PageHeader.defaultProps = {
  children: null,
  streakCount: 0,
  notificationCount: 0,
  goBackLink: null,
  cartData: [],
  setIsCartOpen: () => { },
  setIsNotificationOpen: () => { },
  cartCount: 0,
  languageSelector: null,
  darkModeToggle: null,
  extraActions: null,
};

const SectionHeader = PageSectionHeader;
SectionHeader.Head = PageSectionHeaderHead;
SectionHeader.Action = PageSectionHeaderAction;

export default PageHeader;
export { SectionHeader };
